import clsx from 'clsx';
import { Interactive } from '@gandi/ui';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "InteractiveBlock-root_CIHTK",
  "big-button": "InteractiveBlock-big-button_3Su3O",
  "list-item": "InteractiveBlock-list-item_1F8he"
};
export function InteractiveBlock({
  children,
  className,
  tagName,
  ...props
}) {
  const borderStyle = tagName === 'li' ? styles['list-item'] : styles['big-button'];
  return /*#__PURE__*/_jsx(Interactive, {
    ...props,
    className: clsx(styles.root, borderStyle, className),
    children: children
  });
}